import { render } from "./EcItemContent.vue?vue&type=template&id=1b3c2f20&scoped=true"
import script from "./EcItemContent.vue?vue&type=script&lang=js"
export * from "./EcItemContent.vue?vue&type=script&lang=js"

import "./EcItemContent.vue?vue&type=style&index=0&id=1b3c2f20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b3c2f20"]])

export default __exports__